export default __webpack_public_path__ + "static/media/nyrasis.82a43076.jpg";